import { useEffect, useState } from "react";
import Notification from "../../../../components/toast";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { schema } from "./schema";
import LibBoolean from "../../../../util/libBool";
import reqCredenciais from "../../../../services/reqMultiTenant/reqCredenciais";

export const IndexHook = ({
	isOpenModalRegister,
	ident,
	idTable,
	selectedData,
	setSelectData,
	fetchID,
	reloadData,
	insert,
}) => {
	const {
		register,
		handleSubmit,
		setValue,
		setFocus,
		reset,
		control,
		formState: { errors, isSubmitting },
	} = useForm({
		mode: "onSubmit",
		resolver: zodResolver(schema),
		defaultValues: {
			id_credenciais: 0,
			id_credenciais_tipo: 0,
			descricao: "",
			url: "",
			api_key: "",
			obs: "",
			ativo: true,
		},
	});

	const [loading, setLoading] = useState(false);
	const [listTipos, setListTipos] = useState([]);

	const handleCloseModalRegister = () => {
		const event = new CustomEvent(`${ident}`);
		window.dispatchEvent(event);
	};

	//#region Fetch
	useEffect(() => {
		const fetchTipos = async () => {
			try {
				const res = await reqCredenciais.listTipos();
				setListTipos(res.data);
			} catch (error) {
				console.error("Erro ao carregar tipos de credenciais", error);
			}
		};

		if (isOpenModalRegister) {
			fetchTipos();

			const id =
				typeof selectedData[idTable] === "number" && !isNaN(selectedData[idTable])
					? selectedData[idTable]
					: 0;

			if (id > 0) {
				fetch(id);
			}
		} else {
			if (setSelectData) setSelectData({});
			reset();
		}
	}, [isOpenModalRegister, selectedData]);

	const fetch = async (id) => {
		try {
			setLoading(true);

			const response = await fetchID(id);

			if (response.data && typeof response.data === "object") {
				const data = response.data;
				const newData = processNewData(data);

				Object.keys(newData).forEach((field) => {
					setValue(field, newData[field]);
				});
			}
		} catch (error) {
			Notification.showToast({
				message: error.message,
				type: "warning",
			});
		} finally {
			setLoading(false);
		}
	};

	const processNewData = (data) => {
		return {
			...data,
			ativo: typeof data.ativo === 'boolean' ? data.ativo : (data.ativo === 'SIM' || data.ativo === 'TRUE' || data.ativo === 'S'),
		};
	};
	//#endregion

	const getReturnUpdated = (response) => {
		if (Array.isArray(response.data)) {
			return response.data[0];
		} else if (typeof response.data === "object") {
			return response.data;
		} else {
			throw new Error("Formato do retorno inválido.");
		}
	};

	//#region onSubmit
	const handleOnSubmit = async (data) => {
		try {
			const newData = ValidateSubmit(data);
			const oldID = data[idTable];

			const response = await insert(newData);

			const returnUpdated = getReturnUpdated(response);
			const currentId = returnUpdated[idTable];

			await reloadData(oldID, currentId);

			Notification.showToast({
				message: "Credencial salva com sucesso.",
				type: "success",
			});
			reset();
			handleCloseModalRegister();
		} catch (error) {
			Notification.showToast({
				message: error.message,
				type: "error",
			});
		}
	};

	const ValidateSubmit = (data) => {
		return {
			...data,
			ativo: LibBoolean.booleanToStr(data.ativo),
		};
	};
	//#endregion

	return {
		handleOnSubmit,
		handleCloseModalRegister,

		register,
		handleSubmit,
		setValue,
		control,
		setFocus,

		loading,
		errors,
		isSubmitting,
		listTipos,
	};
};
